import { P2GBox } from '@parcel2go/core-ui';
import { SmartSendFilterContext, SmartSendSummary } from '../../lib/helpers/SmartSendFilterApplier';
import ManifestReminder from '../manifests/ManifestReminder';
import SmartSendFiltering from './filter/SmartSendFiltering';
import SmartSendGroup, { SmartSendItemGroup } from './item/SmartSendGroup';
import NoItems from './NoItems';
import { P2GPagination } from './P2GPagination';
import DefaultCollectionAddress from './DefaultCollectionAddress';
import SmartSendSoldHeaderRow from './SmartSendSoldHeaderRow';
import { SmartSendItemsCache } from '../../lib/cache/SmartSendItemsCache';
import SmartSendSoldItemsActionBar from './actions/SmartSendSoldItemsActionBar';
import { P2GImageMessage } from '~/components/imagemessage';
import { isFixSpecificIssue } from './isFixSpecificIssue';
import { useMemo } from 'react';
import TabMessage from './TabMessage';

interface props {
  filter: SmartSendFilterContext;
  filterKey: string;
  summary: SmartSendSummary;
  groups: SmartSendItemGroup[];
  isXs: boolean;
  setPaging: (page: number, pageSize: number) => void;
}

const SoldItemsList: React.FC<props> = (props) => {
  const isFix = isFixSpecificIssue(props.filter);
  const isInitial = useMemo(() => props.summary.states.includes('INITIAL'), [props.summary.states]);

  return (
    <P2GBox pb={2}>
      <SmartSendFiltering filterKey={props.filterKey} filter={props.filter} summary={props.summary} isXs={props.isXs} />
      <ManifestReminder />
      {isInitial ? (
        <P2GImageMessage
          image="/theme/smartsend/notifications/loading-items.png"
          message="Loading items..."
          contentKey="image-smartsend-items-loading"
          showLoader
        />
      ) : (
        <>
          {props.groups.length === 0 ? (
            <NoItems filterKey={props.filterKey} />
          ) : (
            <P2GPagination
              take={props.filter.CurrentFilter.Take}
              skip={props.filter.CurrentFilter.Skip}
              itemCount={props.summary.count}
              isXs={props.isXs}
              setPaging={props.setPaging}
            >
              <P2GBox>
                {!isFix && !props.isXs && (
                  <P2GBox mb={2}>
                    <SmartSendSoldHeaderRow
                      filterKey={props.filterKey}
                      selected={props.summary.selected.length}
                      total={props.summary.count}
                      filter={props.filter}
                    />
                  </P2GBox>
                )}

                <TabMessage filterName={props.filter.CurrentFilter.Name} wrapper={(x) => <P2GBox my={2}>{x}</P2GBox>} />

                {props.groups.map((group, i) => (
                  <SmartSendGroup
                    isXs={props.isXs}
                    key={`${group.Title}_${i}_${props.isXs}`}
                    group={group}
                    showTitle={!props.isXs && props.filter.CurrentFilter.ShowAsGroup}
                  />
                ))}
              </P2GBox>
              {!isFix && <DefaultCollectionAddress isXs={props.isXs} />}
            </P2GPagination>
          )}
        </>
      )}
      <SmartSendSoldItemsActionBar
        isFix={isFix}
        filterKey={props.filterKey}
        isXs={props.isXs}
        smartSendItemsCache={SmartSendItemsCache}
        className="p2g-neworders-actionbar"
      />
    </P2GBox>
  );
};

export default SoldItemsList;
